import React from "react";
import { getProducts } from "../api/services";
import { useData } from "../hooks/useData";
import { Card, KpiCard, Loading } from "../components/common/UI";
import { MoneyBar, MonthlyCombo } from "../components/charts/SimpleCharts";
import { fmtKop, fmtNum, fmtPct } from "../utils/format";
import styles from "./pages.module.css";

export default function Products() {
  const { data, loading } = useData(getProducts, []);
  if (loading || !data) return <Loading />;

  return (
    <div className={styles.page}>
      <div className={styles.pageHead}>
        <div>
          <h1 className={styles.pageTitle}>Продукты</h1>
          <div className={styles.pageSub}>
            Три основных продукта воронки: пользователи, активность и выручка по месяцам
          </div>
        </div>
      </div>

      {data.products.map((p) => <ProductSection key={p.key} product={p} />)}
    </div>
  );
}

function ProductSection({ product: p }) {
  const t = p.totals || {};
  const hasRevenue = (t.revenue_kop || 0) > 0;

  return (
    <Card>
      <div style={{ display: "flex", alignItems: "baseline", gap: 12, marginBottom: 14 }}>
        <div style={{ fontWeight: 700, fontSize: 18 }}>{p.title}</div>
        <div style={{ color: "var(--text-dim)", fontSize: 12.5 }}>{p.role}</div>
      </div>

      <div className={styles.kpiGrid} style={{ marginBottom: 18 }}>
        <KpiCard label="Пользователи" value={fmtNum(t.users)} />
        <KpiCard label="Активные" value={fmtNum(t.active)} />
        <KpiCard label="Оплатившие" value={fmtNum(t.pays)} />
        <KpiCard
          label="Выручка (2026)"
          value={hasRevenue ? fmtKop(t.revenue_kop, { short: true }) : "0 ₽"}
          accent={hasRevenue ? "var(--accent)" : undefined}
        />
      </div>

      <div className={styles.grid2}>
        <div>
          <div style={{ color: "var(--text-dim)", fontSize: 13, marginBottom: 8 }}>
            Пользователи по месяцам
          </div>
          <MonthlyCombo months={p.months} />
        </div>
        <div>
          <div style={{ color: "var(--text-dim)", fontSize: 13, marginBottom: 8 }}>
            Выручка по месяцам
          </div>
          {hasRevenue ? (
            <MoneyBar
              labels={p.revenue_months.map((m) => m.label)}
              values={p.revenue_months.map((m) => m.revenue_kop)}
            />
          ) : (
            <div style={{ color: "var(--text-mute)", padding: "60px 0", textAlign: "center" }}>
              Выручки пока нет
            </div>
          )}
        </div>
      </div>

      <div style={{
        display: "flex", flexWrap: "wrap", gap: "6px 26px",
        marginTop: 14, paddingTop: 12, borderTop: "1px solid var(--border)",
        color: "var(--text-dim)", fontSize: 12.5,
      }}>
        <span>Переходы на сайт (сводно): <b style={{ color: "var(--text)" }}>
          {t.visits != null ? fmtNum(t.visits) : "нет данных"}</b></span>
        <span>Отказы: <b style={{ color: "var(--text)" }}>
          {t.bounce_rate != null ? fmtPct(t.bounce_rate) : "—"}</b></span>
        <span>Конверсия в оплату: <b style={{ color: "var(--text)" }}>
          {t.pay_share != null ? fmtPct(t.pay_share * 100) : "—"}</b></span>
        <span>Средний платёж: <b style={{ color: "var(--text)" }}>
          {t.avg_payment_kop != null ? fmtKop(t.avg_payment_kop) : "—"}</b></span>
      </div>
    </Card>
  );
}
